import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card",
  style: {"display":"inline-block"}
}
const _hoisted_2 = {
  key: 0,
  class: "card-body"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "d-flex justify-content-between" }

import { computed, toRef } from 'vue'
    import type { AlternativeFilterReadModel } from '@Alternatives/AlternativesViews/Domain/readmodels'
    import type { AlternativeStatusReadModel } from '@Alternatives/Statuses/Domain/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StatusFilter',
  props: {
    propRm: {},
    propStatuses: {}
  },
  emits: ["deleteFilter"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'propRm')
    const statuses = toRef(props, 'propStatuses')

    // ---------------- derived ----------------

    const headerText = computed<string | null>(() =>
    {
        if (!rm.value.Data || rm.value.Data.length === 0)
            return 'Invalid!'

        const selectedStatuses = statuses.value
            .filter(s => rm.value.Data.indexOf(s.Name) !== -1)
            .map(s => s.Name)
            .sort()

        if (rm.value.Type === 'StatusIn')
            return `Status: ${selectedStatuses.join(', ')}`

        if (rm.value.Type === 'StatusNotIn')
            return `Status not in: ${selectedStatuses.join(', ')}`

        return null
    })

    // ---------------- methods ----------------

    function deleteFilter()
    {
        emit('deleteFilter', rm.value)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (rm.value.IsEdited = true)),
      class: "card-header pointer"
    }, _toDisplayString(headerText.value), 1 /* TEXT */),
    (rm.value.IsEdited)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("label", null, "Statuses:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              multiple: "",
              size: "6",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rm.value.Data) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statuses.value, (s) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: s.Name
                }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_4))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, rm.value.Data]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", { class: "dropdown d-inline" }, [
              _cache[5] || (_cache[5] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-danger",
                "data-toggle": "dropdown"
              }, " Delete ", -1 /* CACHED */)),
              _createElementVNode("div", { class: "dropdown-menu" }, [
                _createElementVNode("div", { class: "btn-group" }, [
                  _cache[4] || (_cache[4] = _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-secondary"
                  }, "Cancel", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    onClick: deleteFilter,
                    type: "button",
                    class: "btn btn-danger"
                  }, "Confirm")
                ])
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (rm.value.IsEdited = false)),
              class: "btn btn-primary"
            }, "Update")
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})